import React, { useState } from "react";
import {
    FaMapMarkerAlt,
    FaPhoneAlt,
    FaEnvelope,
    FaFacebookF,
    FaTwitter,
    FaInstagram,
    FaLinkedinIn,
    FaGraduationCap,
    FaArrowRight,
    FaPaperPlane,
    FaChevronRight,
    FaClock,
    FaAward,
    FaBookOpen,
    FaShieldAlt,
    FaCheckCircle,
    FaGlobe,
    FaStar,
} from "react-icons/fa";

const foundationFooterStyles = `
.jlw-footer {
    --jlw-navy: #071a35;
    --jlw-navy-light: #102a4c;
    --jlw-blue: #163b66;
    --jlw-gold: #d9ad55;
    --jlw-gold-light: #f0d697;
    --jlw-white: #ffffff;
    --jlw-muted: #aebdd0;
    --jlw-border: rgba(255, 255, 255, 0.12);

    position: relative;
    overflow: hidden;
    width: 100%;
    color: var(--jlw-white);
    background: var(--jlw-navy);
    font-family: inherit;
    isolation: isolate;
}

.jlw-footer *,
.jlw-footer *::before,
.jlw-footer *::after {
    box-sizing: border-box;
}

.jlw-footer a {
    color: inherit;
    text-decoration: none;
}

.jlw-footer-accent {
    display: grid;
    grid-template-columns: 1fr 1.5fr 1fr;
    height: 5px;
}

.jlw-footer-accent span:nth-child(1) {
    background: var(--jlw-gold);
}

.jlw-footer-accent span:nth-child(2) {
    background: var(--jlw-gold-light);
}

.jlw-footer-accent span:nth-child(3) {
    background: var(--jlw-blue);
}

.jlw-footer-main {
    position: relative;
    display: grid;
    grid-template-columns: 1.2fr 1.2fr 1fr;
    gap: 55px;
    width: min(1240px, calc(100% - 64px));
    margin: 0 auto;
    padding: 78px 0 62px;
}

.jlw-footer-main::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background: linear-gradient(
        90deg,
        transparent,
        rgba(217, 173, 85, 0.32),
        transparent
    );
    content: "";
}

.jlw-footer-brand {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 25px;
}

.jlw-footer-brand-icon {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 62px;
    height: 62px;
    color: var(--jlw-navy);
    background: linear-gradient(
        145deg,
        var(--jlw-gold-light),
        var(--jlw-gold)
    );
    border-radius: 16px 5px 16px 5px;
    box-shadow: 0 8px 24px rgba(217, 173, 85, 0.14);
    font-size: 31px;
}

.jlw-footer-brand-text h2 {
    margin: 0 0 7px;
    color: var(--jlw-white);
    font-size: clamp(17px, 1.7vw, 22px);
    font-weight: 800;
    line-height: 1.35;
    letter-spacing: -0.5px;
}

.jlw-footer-brand-text span {
    color: var(--jlw-gold-light);
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 1.8px;
    text-transform: uppercase;
}

.jlw-footer-description {
    max-width: 410px;
    margin: 0;
    color: var(--jlw-muted);
    font-size: 14px;
    line-height: 1.95;
}

.jlw-footer-values {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 26px;
}

.jlw-footer-value {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 9px 11px;
    color: #e9eef5;
    background: rgba(255, 255, 255, 0.045);
    border: 1px solid var(--jlw-border);
    border-radius: 7px;
    font-size: 11px;
    font-weight: 700;
}

.jlw-footer-value svg {
    color: var(--jlw-gold);
    font-size: 13px;
}

.jlw-footer-social-area {
    margin-top: 30px;
}

.jlw-footer-social-label {
    display: block;
    margin-bottom: 13px;
    color: var(--jlw-white);
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.6px;
}

.jlw-footer-social-links {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.jlw-footer-social-links a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 39px;
    height: 39px;
    color: #e7edf5;
    background: rgba(255, 255, 255, 0.055);
    border: 1px solid var(--jlw-border);
    border-radius: 10px;
    font-size: 14px;
    transition: color 0.25s ease, background 0.25s ease,
        transform 0.25s ease, border-color 0.25s ease;
}

.jlw-footer-social-links a:hover {
    color: var(--jlw-navy);
    background: var(--jlw-gold);
    border-color: var(--jlw-gold);
    transform: translateY(-3px);
}

.jlw-footer-navigation {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 28px;
}

.jlw-footer-column-title,
.jlw-footer-section-title {
    display: flex;
    align-items: center;
    gap: 11px;
    margin: 0 0 24px;
}

.jlw-footer-title-icon {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    color: var(--jlw-gold);
    background: rgba(217, 173, 85, 0.11);
    border: 1px solid rgba(217, 173, 85, 0.22);
    border-radius: 9px;
    font-size: 13px;
}

.jlw-footer-column-title h3,
.jlw-footer-section-title h3 {
    margin: 0;
    color: var(--jlw-white);
    font-size: 15px;
    font-weight: 800;
    line-height: 1.4;
}

.jlw-footer-column-title::after {
    display: none;
}

.jlw-footer-list {
    display: grid;
    gap: 15px;
    margin: 0;
    padding: 0;
    list-style: none;
}

.jlw-footer-list a {
    display: inline-flex;
    align-items: center;
    gap: 9px;
    color: var(--jlw-muted);
    font-size: 12px;
    line-height: 1.6;
    transition: color 0.2s ease, transform 0.2s ease;
}

.jlw-footer-list a svg {
    flex-shrink: 0;
    color: var(--jlw-gold);
    font-size: 9px;
}

.jlw-footer-list a:hover {
    color: var(--jlw-gold-light);
    transform: translateX(3px);
}

.jlw-footer-contact-section {
    min-width: 0;
}

.jlw-footer-contact-grid {
    display: grid;
    gap: 17px;
}

.jlw-footer-contact-card {
    display: flex;
    align-items: flex-start;
    gap: 13px;
    min-width: 0;
}

.jlw-footer-contact-icon {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    color: var(--jlw-gold);
    background: rgba(217, 173, 85, 0.09);
    border: 1px solid rgba(217, 173, 85, 0.19);
    border-radius: 10px;
    font-size: 13px;
}

.jlw-footer-contact-content {
    min-width: 0;
    padding-top: 2px;
}

.jlw-footer-contact-content > span {
    display: block;
    margin-bottom: 5px;
    color: var(--jlw-white);
    font-size: 12px;
    font-weight: 800;
}

.jlw-footer-contact-content p,
.jlw-footer-contact-content a {
    display: block;
    overflow-wrap: anywhere;
    margin: 0;
    color: var(--jlw-muted);
    font-size: 12px;
    line-height: 1.8;
}

.jlw-footer-contact-content a:hover {
    color: var(--jlw-gold-light);
}

.jlw-footer-connect {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 30px;
    width: min(1240px, calc(100% - 64px));
    margin: 0 auto;
    padding: 26px 30px;
    background: linear-gradient(
        115deg,
        rgba(22, 59, 102, 0.8),
        rgba(16, 42, 76, 0.92)
    );
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 14px;
}

.jlw-footer-connect-content {
    display: flex;
    align-items: center;
    gap: 16px;
    min-width: 0;
}

.jlw-footer-connect-icon {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    color: var(--jlw-navy);
    background: var(--jlw-gold);
    border-radius: 12px;
    font-size: 19px;
}

.jlw-footer-connect-content h4 {
    margin: 0 0 5px;
    color: var(--jlw-white);
    font-size: 16px;
    font-weight: 800;
}

.jlw-footer-connect-content p {
    margin: 0;
    color: var(--jlw-muted);
    font-size: 12px;
    line-height: 1.7;
}

.jlw-footer-newsletter {
    display: flex;
    flex-shrink: 0;
    width: min(430px, 48%);
    gap: 9px;
}

.jlw-footer-newsletter input {
    width: 100%;
    min-width: 0;
    height: 47px;
    padding: 0 15px;
    color: var(--jlw-white);
    background: rgba(4, 16, 34, 0.55);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 8px;
    outline: none;
    font: inherit;
    font-size: 12px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.jlw-footer-newsletter input::placeholder {
    color: #8e9eb3;
}

.jlw-footer-newsletter input:focus {
    border-color: var(--jlw-gold);
    box-shadow: 0 0 0 3px rgba(217, 173, 85, 0.12);
}

.jlw-footer-newsletter button {
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    gap: 9px;
    min-height: 47px;
    padding: 0 18px;
    color: var(--jlw-navy);
    background: var(--jlw-gold);
    border: 1px solid var(--jlw-gold);
    border-radius: 8px;
    cursor: pointer;
    font: inherit;
    font-size: 12px;
    font-weight: 800;
    transition: background 0.2s ease, transform 0.2s ease;
}

.jlw-footer-newsletter button:hover {
    background: var(--jlw-gold-light);
    transform: translateY(-1px);
}

.jlw-footer-newsletter button:disabled {
    cursor: not-allowed;
    opacity: 0.75;
    transform: none;
}

.jlw-footer-newsletter-status {
    width: min(1240px, calc(100% - 64px));
    margin: 10px auto 0;
    color: var(--jlw-gold-light);
    font-size: 12px;
    line-height: 1.6;
}

.jlw-footer-motto {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    width: min(1240px, calc(100% - 64px));
    margin: 0 auto;
    padding: 35px 0;
}

.jlw-footer-motto span {
    width: 45px;
    height: 1px;
    background: var(--jlw-gold);
    opacity: 0.65;
}

.jlw-footer-motto p {
    margin: 0;
    color: var(--jlw-gold-light);
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 1.4px;
    line-height: 1.8;
    text-align: center;
    text-transform: uppercase;
}

.jlw-footer-bottom {
    background: #041126;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.jlw-footer-bottom-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    width: min(1240px, calc(100% - 64px));
    margin: 0 auto;
    padding: 23px 0;
}

.jlw-footer-copyright {
    margin: 0;
    color: #91a2b8;
    font-size: 11px;
    line-height: 1.8;
}

.jlw-footer-copyright strong {
    color: #e2eaf4;
    font-weight: 700;
}

.jlw-footer-bottom-links {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 11px;
}

.jlw-footer-bottom-links a {
    color: #91a2b8;
    font-size: 11px;
    transition: color 0.2s ease;
}

.jlw-footer-bottom-links a:hover {
    color: var(--jlw-gold-light);
}

.jlw-footer-bottom-links span {
    color: #455a74;
    font-size: 10px;
}

.jlw-footer-credit {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    padding: 12px 20px;
    color: #8193aa;
    background: #030d1d;
    font-size: 10px;
    letter-spacing: 0.3px;
    text-align: center;
}

.jlw-footer-credit svg {
    color: var(--jlw-gold);
    font-size: 10px;
}

@media (min-width: 1500px) {
    .jlw-footer-main,
    .jlw-footer-connect,
    .jlw-footer-newsletter-status,
    .jlw-footer-motto,
    .jlw-footer-bottom-inner {
        width: min(1320px, calc(100% - 100px));
    }
}

@media (max-width: 1100px) {
    .jlw-footer-main {
        grid-template-columns: 1fr 1fr;
        gap: 45px;
    }

    .jlw-footer-brand-section {
        grid-column: 1 / -1;
    }

    .jlw-footer-description {
        max-width: 650px;
    }

    .jlw-footer-navigation {
        gap: 24px;
    }

    .jlw-footer-connect {
        align-items: flex-start;
        flex-direction: column;
    }

    .jlw-footer-newsletter {
        width: 100%;
        max-width: 600px;
    }
}

@media (max-width: 700px) {
    .jlw-footer-main,
    .jlw-footer-connect,
    .jlw-footer-newsletter-status,
    .jlw-footer-motto,
    .jlw-footer-bottom-inner {
        width: calc(100% - 36px);
    }

    .jlw-footer-main {
        grid-template-columns: 1fr;
        gap: 39px;
        padding: 48px 0 38px;
    }

    .jlw-footer-brand-section {
        grid-column: auto;
    }

    .jlw-footer-brand {
        align-items: flex-start;
        gap: 13px;
    }

    .jlw-footer-brand-icon {
        width: 52px;
        height: 52px;
        border-radius: 13px 4px 13px 4px;
        font-size: 26px;
    }

    .jlw-footer-brand-text h2 {
        font-size: 18px;
    }

    .jlw-footer-brand-text span {
        font-size: 9px;
        letter-spacing: 1.1px;
    }

    .jlw-footer-navigation {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 20px;
    }

    .jlw-footer-column-title,
    .jlw-footer-section-title {
        gap: 8px;
        margin-bottom: 19px;
    }

    .jlw-footer-column-title h3,
    .jlw-footer-section-title h3 {
        font-size: 13px;
    }

    .jlw-footer-title-icon {
        width: 30px;
        height: 30px;
    }

    .jlw-footer-list {
        gap: 13px;
    }

    .jlw-footer-list a {
        align-items: flex-start;
        font-size: 11px;
    }

    .jlw-footer-connect {
        gap: 20px;
        padding: 22px 18px;
    }

    .jlw-footer-connect-content {
        align-items: flex-start;
        gap: 12px;
    }

    .jlw-footer-connect-icon {
        width: 41px;
        height: 41px;
        font-size: 16px;
    }

    .jlw-footer-newsletter {
        flex-direction: column;
    }

    .jlw-footer-newsletter button {
        width: 100%;
    }

    .jlw-footer-motto {
        gap: 10px;
        padding: 28px 0;
    }

    .jlw-footer-motto span {
        width: 20px;
        flex-shrink: 0;
    }

    .jlw-footer-motto p {
        font-size: 9px;
        letter-spacing: 0.8px;
    }

    .jlw-footer-bottom-inner {
        align-items: flex-start;
        flex-direction: column;
        gap: 13px;
        padding: 20px 0;
    }

    .jlw-footer-bottom-links {
        justify-content: flex-start;
        gap: 8px;
    }

    .jlw-footer-bottom-links a {
        font-size: 10px;
    }
}

@media (max-width: 380px) {
    .jlw-footer-navigation {
        grid-template-columns: 1fr;
        gap: 28px;
    }

    .jlw-footer-values {
        gap: 7px;
    }

    .jlw-footer-value {
        padding: 8px;
        font-size: 10px;
    }

    .jlw-footer-motto span {
        display: none;
    }
}

@media (prefers-reduced-motion: reduce) {
    .jlw-footer *,
    .jlw-footer *::before,
    .jlw-footer *::after {
        scroll-behavior: auto !important;
        transition-duration: 0.01ms !important;
        animation-duration: 0.01ms !important;
        animation-iteration-count: 1 !important;
    }
}
`;

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const [email, setEmail] = useState("");
    const [subscriptionMessage, setSubscriptionMessage] = useState("");

    const handleSubscribe = (event) => {
        event.preventDefault();

        const normalizedEmail = email.trim();

        if (!normalizedEmail) {
            setSubscriptionMessage("Please enter your email address.");
            return;
        }

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailPattern.test(normalizedEmail)) {
            setSubscriptionMessage(
                "Please enter a valid email address."
            );
            return;
        }

        setSubscriptionMessage(
            "Thank you for your interest! Newsletter subscriptions are not connected yet."
        );
    };

    const quickLinks = [
        { label: "Home", href: "#home" },
        { label: "About the Foundation", href: "#about" },
        { label: "Our Leadership", href: "#leadership" },
        { label: "Programs & Initiatives", href: "#programs" },
        { label: "Contact Us", href: "#contact" },
    ];

    const academicLinks = [
        { label: "Educational Programs", href: "#education" },
        { label: "Skills Development", href: "#skills" },
        { label: "Leadership Development", href: "#leadership" },
        { label: "Community Empowerment", href: "#community" },
        { label: "Foundation News", href: "#news" },
    ];

    return (
        <>
            <style>{foundationFooterStyles}</style>

            <footer className="jlw-footer">
                <div
                    className="jlw-footer-accent"
                    aria-hidden="true"
                >
                    <span />
                    <span />
                    <span />
                </div>

                <div className="jlw-footer-main">
                    <section className="jlw-footer-brand-section">
                        <div className="jlw-footer-brand">
                            <div className="jlw-footer-brand-icon">
                                <FaGraduationCap />
                            </div>

                            <div className="jlw-footer-brand-text">
                                <h2>
                                    Jana L. Williams
                                    <br />
                                    Educational Foundation
                                </h2>

                                <span>
                                    Education • Empowerment • Excellence
                                </span>
                            </div>
                        </div>

                        <p className="jlw-footer-description">
                            Advancing educational opportunities, inspiring
                            leadership, and empowering individuals and
                            communities to build a brighter, more sustainable
                            future through knowledge, skills, and service.
                        </p>

                        <div className="jlw-footer-values">
                            <div className="jlw-footer-value">
                                <FaAward />
                                <span>Excellence</span>
                            </div>

                            <div className="jlw-footer-value">
                                <FaBookOpen />
                                <span>Education</span>
                            </div>

                            <div className="jlw-footer-value">
                                <FaShieldAlt />
                                <span>Integrity</span>
                            </div>
                        </div>

                        <div className="jlw-footer-social-area">
                            <span className="jlw-footer-social-label">
                                Connect With Our Foundation
                            </span>

                            <div className="jlw-footer-social-links">
                                <a
                                    href="https://www.facebook.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Facebook"
                                >
                                    <FaFacebookF />
                                </a>

                                <a
                                    href="https://www.instagram.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Instagram"
                                >
                                    <FaInstagram />
                                </a>

                                <a
                                    href="https://www.linkedin.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="LinkedIn"
                                >
                                    <FaLinkedinIn />
                                </a>

                                <a
                                    href="https://x.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="X"
                                >
                                    <FaTwitter />
                                </a>
                            </div>
                        </div>
                    </section>

                    <div className="jlw-footer-navigation">
                        <nav className="jlw-footer-column" aria-label="Quick links">
                            <div className="jlw-footer-column-title">
                                <span className="jlw-footer-title-icon">
                                    <FaArrowRight />
                                </span>
                                <h3>Explore</h3>
                            </div>

                            <ul className="jlw-footer-list">
                                {quickLinks.map((link) => (
                                    <li key={link.label}>
                                        <a href={link.href}>
                                            <FaChevronRight />
                                            <span>{link.label}</span>
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </nav>

                        <nav
                            className="jlw-footer-column"
                            aria-label="Foundation programs"
                        >
                            <div className="jlw-footer-column-title">
                                <span className="jlw-footer-title-icon">
                                    <FaBookOpen />
                                </span>
                                <h3>Our Work</h3>
                            </div>

                            <ul className="jlw-footer-list">
                                {academicLinks.map((link) => (
                                    <li key={link.label}>
                                        <a href={link.href}>
                                            <FaChevronRight />
                                            <span>{link.label}</span>
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </div>

                    <section
                        className="jlw-footer-contact-section"
                        aria-label="Foundation contact information"
                    >
                        <div className="jlw-footer-section-title">
                            <span className="jlw-footer-title-icon">
                                <FaMapMarkerAlt />
                            </span>
                            <h3>Get in Touch</h3>
                        </div>

                        <div className="jlw-footer-contact-grid">
                            <div className="jlw-footer-contact-card">
                                <div className="jlw-footer-contact-icon">
                                    <FaMapMarkerAlt />
                                </div>

                                <div className="jlw-footer-contact-content">
                                    <span>Visit Our Foundation</span>
                                    <p>
                                        Liberia
                                    </p>
                                </div>
                            </div>

                            <div className="jlw-footer-contact-card">
                                <div className="jlw-footer-contact-icon">
                                    <FaPhoneAlt />
                                </div>

                                <div className="jlw-footer-contact-content">
                                    <span>Call Us</span>
                                    <p>
                                        Contact details coming soon
                                    </p>
                                </div>
                            </div>

                            <div className="jlw-footer-contact-card">
                                <div className="jlw-footer-contact-icon">
                                    <FaEnvelope />
                                </div>

                                <div className="jlw-footer-contact-content">
                                    <span>Email Us</span>
                                    <p>
                                        Please use our official contact page
                                    </p>
                                </div>
                            </div>

                            <div className="jlw-footer-contact-card">
                                <div className="jlw-footer-contact-icon">
                                    <FaClock />
                                </div>

                                <div className="jlw-footer-contact-content">
                                    <span>Office Hours</span>
                                    <p>
                                        Monday – Friday
                                        <br />
                                        Official hours to be confirmed
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <div className="jlw-footer-connect">
                    <div className="jlw-footer-connect-content">
                        <div className="jlw-footer-connect-icon">
                            <FaEnvelope />
                        </div>

                        <div>
                            <h4>Stay Connected</h4>
                            <p>
                                Keep up with foundation news, programs,
                                opportunities, and community initiatives.
                            </p>
                        </div>
                    </div>

                    <form
                        className="jlw-footer-newsletter"
                        onSubmit={handleSubscribe}
                    >
                        <input
                            type="email"
                            name="email"
                            value={email}
                            onChange={(event) => {
                                setEmail(event.target.value);
                                setSubscriptionMessage("");
                            }}
                            placeholder="Enter your email address"
                            aria-label="Email address"
                            autoComplete="email"
                            required
                        />

                        <button type="submit">
                            Subscribe
                            <FaPaperPlane />
                        </button>
                    </form>
                </div>

                {subscriptionMessage && (
                    <p
                        className="jlw-footer-newsletter-status"
                        role="status"
                        aria-live="polite"
                    >
                        {subscriptionMessage}
                    </p>
                )}

                <div className="jlw-footer-motto">
                    <span aria-hidden="true" />

                    <p>
                        Empowering Minds. Inspiring Leaders. Transforming
                        Communities.
                    </p>

                    <span aria-hidden="true" />
                </div>

                <div className="jlw-footer-bottom">
                    <div className="jlw-footer-bottom-inner">
                        <p className="jlw-footer-copyright">
                            © {currentYear}{" "}
                            <strong>
                                Jana L. Williams Educational Foundation.
                            </strong>{" "}
                            All rights reserved.
                        </p>

                        <div className="jlw-footer-bottom-links">
                            <a href="#privacy">Privacy Policy</a>
                            <span aria-hidden="true">|</span>
                            <a href="#terms">Terms &amp; Conditions</a>
                            <span aria-hidden="true">|</span>
                            <a href="#contact">Contact Support</a>
                        </div>
                    </div>
                </div>

                <div className="jlw-footer-credit">
                    <FaGlobe />
                    <span>
                        Building brighter futures through education and
                        opportunity.
                    </span>
                    <FaStar />
                </div>
            </footer>
        </>
    );
};

export default Footer;
